import { render, staticRenderFns } from "./specialSourceControllItem.vue?vue&type=template&id=24e748b7"
import script from "./specialSourceControllItem.vue?vue&type=script&lang=js"
export * from "./specialSourceControllItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports